export interface MegaRecentProduct {
  id: string;
  name: string;
  priceFormatted: string;
  imageUrl: string;
  route: string;
  isNew?: boolean;
  isOnSale?: boolean;
  discountPercent?: number;
  isPreSale?: boolean;
}

export interface MegaQuickLink {
  label: string;
  route: string;
  queryParams?: Record<string, string>;
}

// ── Quick links (franja inferior del mega menú) ─────────────────────────────
export const TIENDA_QUICK_LINKS: MegaQuickLink[] = [
  { label: 'Ofertas',       route: '/tienda', queryParams: { filter: 'ofertas' } },
  { label: 'Novedades',     route: '/tienda', queryParams: { filter: 'novedades' } },
  { label: 'Más vendidos',  route: '/tienda', queryParams: { sort: 'popular' } },
  { label: 'Ver todo',      route: '/tienda' },
];
